import gql from 'graphql-tag';

export const RESET_PASSWORD = gql`
    mutation ResetPassword($email: String!, $password: String!, $passwordResetToken: String!) {
        changePassword(email:$email, password:$password, passwordResetToken:$passwordResetToken)
    }
`;